import type { ReactNode } from "react";
import { Icon } from "../Icons";

type Group = { t: string; items: ReactNode[] };

export function Features() {
  const groups: Group[] = [
    {
      t: "SQL surface",
      items: [
        <>
          <span className="mono">CREATE STREAM</span> and{" "}
          <span className="mono">CREATE MATERIALIZED VIEW</span>
        </>,
        "Moving windows, keyed GROUP BY, and signal operators",
      ],
    },
    {
      t: "Tag mapping",
      items: ["Numeric and boolean Ignition tags", "Path placeholders and UDT parameters"],
    },
    {
      t: "Runtime",
      items: ["Native gateway module, no cloud path", "SQL compiles to an operator graph"],
    },
    {
      t: "Trust",
      items: [
        "Runs entirely on your gateway",
        "No outbound telemetry",
        "Offline license verification",
      ],
    },
  ];

  return (
    <section className="section" id="features" style={{ background: "var(--bg-subtle)" }}>
      <div className="section-inner">
        <div className="section-header">
          <div className="eyebrow">05 · Product surface</div>
          <h2>The parts that matter on a gateway.</h2>
          <p className="lede">
            SQL authoring, tag mapping, native execution, and operator visibility in the Ignition
            Gateway.
          </p>
        </div>
        <div
          className="features-grid"
          style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 20 }}
        >
          {groups.map((g, i) => (
            <div
              key={i}
              className="card"
              style={{ padding: "24px 22px", display: "flex", flexDirection: "column", gap: 16 }}
            >
              <div className="eyebrow" style={{ color: "var(--ink-2)" }}>
                {g.t}
              </div>
              <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: 10 }}>
                {g.items.map((it, j) => (
                  <li
                    key={j}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 9,
                      fontSize: 13.5,
                      color: "var(--ink-2)",
                      lineHeight: 1.5,
                    }}
                  >
                    <span
                      style={{
                        flexShrink: 0,
                        marginTop: 3,
                        color: "var(--ok)",
                        display: "flex",
                      }}
                    >
                      <Icon.Check width={13} height={13} strokeWidth={2.5} />
                    </span>
                    <span style={{ minWidth: 0 }}>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
